import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { SubgroupService } from '../subgroup.service';
import { GroupService } from '../../groups/group.service';
import { Group } from '../../../models/group.model';

@Component({
  selector: 'app-create-subgroup',
  imports: [CommonModule, FormsModule, ReactiveFormsModule, InputTextModule, SelectModule],
  templateUrl: './create-subgroup.component.html'
})
export class CreateSubgroupComponent implements OnDestroy, OnInit {
  @Input() id!: number | null;
  /** Quando aberto a partir do cadastro de produto, pré-seleciona o grupo. */
  @Input() defaultGroupId: number | null = null;
  form!: FormGroup;
  @Output() formSubmitted = new EventEmitter<void>();
  @Output() modalClosed = new EventEmitter<void>();

  groups: Group[] = [];

  constructor(
    private fb: FormBuilder,
    private subgroupService: SubgroupService,
    private groupService: GroupService
  ) {}

  ngOnDestroy(): void {
    this.modalClosed.emit();
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      description: ['', Validators.required],
      groupId: [null as number | null, Validators.required]
    });
    this.groupService.getAll('', null, false, null).subscribe({
      next: res => {
        this.groups = res.data;
        if (!this.id && this.defaultGroupId != null) {
          this.form.patchValue({ groupId: this.defaultGroupId });
        }
      }
    });
    if (this.id) {
      this.getData();
    }
  }

  getData(): void {
    this.subgroupService.getById(this.id as number).subscribe({
      next: res => this.form.patchValue(res.data)
    });
  }

  isFieldInvalid(fieldName: string): boolean {
    const field = this.form.get(fieldName);
    return field ? field.invalid && (field.dirty || field.touched) : false;
  }

  onSubmit(): void {
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach(key => this.form.get(key)?.markAsTouched());
      return;
    }
    const body = this.form.value;
    if (this.id) {
      this.subgroupService.update(this.id, body).subscribe({
        next: () => this.formSubmitted.emit()
      });
    } else {
      this.subgroupService.create(body).subscribe({
        next: () => this.formSubmitted.emit()
      });
    }
  }
}
